import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

const activities = [
  {
    title: "Batting",
    image: "/assets/images/istockphoto-1320338926-612x612.jpg",
  },
  {
    title: "Bowling",
    image: "/assets/images/depositphotos_90061412-stock-photo-cricket-player-bowler-reaches-his.jpg",
  },
  {
    title: "Fielding",
    image: "/assets/images/istockphoto-494309914-612x612.jpg",
  },
  {
    title: "Personal Coaching",
    image: "/assets/images/default.avif",
  },
  {
    title: "Fitness Training",
    image: "/assets/images/depositphotos_40094079-stock-photo-cricket-game-action.jpg",
  },
  {
    title: "Match Practice",
    image:
      "/assets/images/cricket-bat-leans-against-stumps-rich-green-pitch-red-ball-rests-nearby-sport-activity-equipment-grass-sunny-outdoors-summer-384919252.webp",
  },
];

const OurActivity = () => {
  return (
    <section id="our-activity-section" className="our-activity-section">
      <div className="container">
        <h2 className="text-center">Our Program</h2>
 <p className="contact-subtext">
            Improve agility, reflexes, and ground coverage with advanced fielding drills.
            </p>
        <Swiper
          modules={[Navigation, Autoplay]}
          spaceBetween={30}
          slidesPerView={4}
          navigation
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          breakpoints={{
            0: { slidesPerView: 1 },
            576: { slidesPerView: 2 },
            992: { slidesPerView: 3 },
            1200: { slidesPerView: 4 },
          }}
        >
          {activities.map((item, index) => (
            <SwiperSlide key={index}>
              <div
                className="activity-card text-center"
                style={{
                  width: "100%",
                }}
              >
                <img
                  src={item.image}
                  alt={item.title}
                  className="img-fluid"
                  style={{
                    width: "100%",          // ✅ mobile full width
                    height: window.innerWidth < 576 ? "220px" : "260px",
                    objectFit: "cover",
                    borderRadius: "12px",
                  }}
                />
                <h5
                  className="mt-3"
                  style={{
                    fontWeight: "600",
                  }}
                >
                  {item.title}
                </h5>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default OurActivity;
